export const getMarketPlaces = ({
  marketplaceReducer: { marketplaces = [] } = {},
}) => marketplaces;
export const getMarketplaceFilter = ({
  marketplaceReducer: { filter = {} } = {},
}) => filter;
export const getMarketPlaceCount = ({
  marketplaceReducer: { count = 0 } = {},
}) => count;
